export default "__VITE_ASSET__O6Drb1j2b438NFIx$mgA0w__"